import type { EntityValidationRules } from "../services/validationService";
import type PermissionType from "./permissionType";

export default class Role {
  id: string;
  readonly name: string;
  readonly usersInRoleCount: string;
  permissionAreaId: string;
  permissionType: PermissionType;
}

export const RoleValidationRules: EntityValidationRules<Role> = {
  permissionAreaId: {
    required: true,
  },
  permissionType: {
    required: true,
  },
};
